export function isTargetClickable(target: HTMLElement) {
  if (target.closest('[action-name]') || target.closest('a')) {
    return true;
  }
  const closest = target.closest('[app-link][valid-link]');
  if (!closest) {
    return false;
  }
  if (!closest.querySelector('.submenu') && !target.closest('.submenu')) {
    return true;
  }

  return false;
}

export function setWhiteBackgroundIfNothingSet() {
  const computed = window.getComputedStyle(document.body);
  const hasBackground =
    computed.backgroundColor !== 'rgba(0, 0, 0, 0)' || // przezroczysty
    computed.backgroundImage !== 'none';
  if (!hasBackground) {
    document.body.style.backgroundColor = 'rgba(255, 255, 255, 1)';
  }
}
